import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c7d494cc")

_pushScopeId("data-v-c7d494cc")
const _hoisted_1 = {
  key: 0,
  class: "navbar-web"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_4 = {
  key: 1,
  class: "navbar-mobile",
  style: {"padding-top":"-10px"}
}
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  class: "nav-icon",
  src: "/assets/icons/classes-icon.png"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  class: "nav-icon",
  src: "/assets/icons/trainers-icon.png"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  class: "nav-icon",
  src: "/assets/icons/recommended-icon.png"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  class: "nav-icon",
  src: "/assets/icons/schedule-icon.png"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_ion_avatar = _resolveComponent("ion-avatar")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")

  return (_openBlock(), _createBlock(_component_ion_toolbar, null, {
    default: _withId(() => [
      (_ctx.isWeb)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode("img", {
              style: {"float":"left","height":"40px","margin":"0 10px"},
              src: _ctx.client.favIconLink
            }, null, 8, ["src"]),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.webNav, (page, index) => {
              return (_openBlock(), _createBlock("span", { key: index }, [
                (_ctx.pageName == 'Landing' && page == 'HOME' && !_ctx.isAuth)
                  ? (_openBlock(), _createBlock(_component_ion_button, {
                      key: 0,
                      href: "#",
                      slot: "start",
                      fill: "clear",
                      color: "primary"
                    }, {
                      default: _withId(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.pageName != 'Landing' && page == 'HOME' && !_ctx.isAuth)
                  ? (_openBlock(), _createBlock(_component_ion_button, {
                      key: 1,
                      href: "#",
                      slot: "start",
                      fill: "clear",
                      color: "medium"
                    }, {
                      default: _withId(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.pageName != 'Join' && page == 'JOIN NOW' && !_ctx.isAuth)
                  ? (_openBlock(), _createBlock(_component_ion_button, {
                      key: 2,
                      href: "join",
                      slot: "start",
                      fill: "clear",
                      color: "medium"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(page), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                (_ctx.pageName == 'Join' && page == 'JOIN NOW' && !_ctx.isAuth)
                  ? (_openBlock(), _createBlock(_component_ion_button, {
                      key: 3,
                      href: "join",
                      slot: "start",
                      fill: "clear",
                      color: "primary"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(page), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                (_ctx.pageName != 'About' && page == 'ABOUT US')
                  ? (_openBlock(), _createBlock(_component_ion_button, {
                      key: 4,
                      href: "about",
                      slot: "start",
                      fill: "clear",
                      color: "medium"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(page), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                (_ctx.pageName == 'About' && page == 'ABOUT US')
                  ? (_openBlock(), _createBlock(_component_ion_button, {
                      key: 5,
                      href: "about",
                      slot: "start",
                      fill: "clear",
                      color: "primary"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(page), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                (_ctx.pageName.toLowerCase() == page.toLowerCase())
                  ? (_openBlock(), _createBlock(_component_ion_button, {
                      key: 6,
                      href: page.toLowerCase(),
                      slot: "start",
                      fill: "clear",
                      color: "primary"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(page), 1)
                      ]),
                      _: 2
                    }, 1032, ["href"]))
                  : (page != 'HOME' && page != 'ABOUT US' && page != 'JOIN NOW')
                    ? (_openBlock(), _createBlock(_component_ion_button, {
                        key: 7,
                        href: page.toLowerCase(),
                        slot: "start",
                        fill: "clear",
                        color: "medium"
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(page), 1)
                        ]),
                        _: 2
                      }, 1032, ["href"]))
                    : _createCommentVNode("", true)
              ]))
            }), 128)),
            (_ctx.isAuth)
              ? (_openBlock(), _createBlock(_component_ion_button, {
                  key: 0,
                  fill: "clear",
                  color: "medium",
                  style: {"float":"right"},
                  onClick: _ctx.openPopover
                }, {
                  default: _withId(() => [
                    _createVNode(_component_ion_avatar, {
                      slot: "end",
                      style: {"height":"32px","width":"32px","margin":"0 4px"}
                    }, {
                      default: _withId(() => [
                        (!_ctx.isFetchingProfile)
                          ? (_openBlock(), _createBlock("img", {
                              key: 0,
                              style: {},
                              src: _ctx.userProfile.avatar || _ctx.UserPhoto
                            }, null, 8, ["src"]))
                          : (_openBlock(), _createBlock(_component_ion_spinner, {
                              key: 1,
                              name: "crescent"
                            }))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isWeb)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode(_component_ion_button, {
              class: "tab-btn",
              href: "/classes",
              color: "medium",
              fill: "clear"
            }, {
              default: _withId(() => [
                _createVNode("img", {
                  class: "client-icon",
                  src: _ctx.client.favIconLink
                }, null, 8, ["src"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_button, {
              class: "spacer tab-btn",
              href: "/classes",
              color: "medium",
              fill: "clear"
            }, {
              default: _withId(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_ion_button, {
              class: "spacer tab-btn",
              href: "/coaches",
              color: "medium",
              fill: "clear"
            }, {
              default: _withId(() => [
                _hoisted_6
              ]),
              _: 1
            }),
            _createVNode(_component_ion_button, {
              class: "spacer tab-btn",
              href: "/recommended",
              color: "medium",
              fill: "clear"
            }, {
              default: _withId(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _createVNode(_component_ion_button, {
              class: "spacer tab-btn",
              href: "/schedule",
              color: "medium",
              fill: "clear"
            }, {
              default: _withId(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})